import { inject } from '@angular/core';
import { HttpRequest, HttpHandlerFn } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { throwError } from 'rxjs';
import { AuthService } from '../services/auth/auth.service';

export function authInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
) {
  const router = inject(Router);
  const authToken = inject(AuthService).getToken();
  if (req.url.startsWith(environment.apiUrl)) {
    if (!authToken) {
      router.navigate(['/']);
      return throwError(() => new Error('Token not found'));
    }

    const clonedReq = req.clone({
      setHeaders: {
        Authorization: `Bearer ${authToken}`,
      },
    });
    return next(clonedReq);
  }
  return next(req);
}
